export const lang = {
  //菜单
  menu: {
    Home: "首页",
    device: "设备管理",
    devicelist: "设备列表",
    groupinglist: "分组列表",
    unusuallist: "异常列表",
    resource: "配置管理",
    configuration: "配置列表",
    configurationlist: "设备配置",
    firmware: "批量配置",
    alarmMsg: "故障管理",
    historywarn: "历史告警",
    warnconfiguration: "告警配置",
    currenttimewarn: "实时报警",
    diagnosemessage: "诊断信息",
    graphs: "统计报表",
    onlinerate: "在线率",
    flowstatistics: "流量统计",
    signalstatistics: "信号统计",
    Softwareversion: "软件版本",
    task: "软件管理",
    softwarepackage: "固件管理",
    upgrade: "软件任务",
    system: "系统管理",
    Authoritymanagement: "安全管理",
    customermanagement: "客户管理",
    usercontrol: "用户管理",
    parametermanagement: "参数管理",
    RemoteService: "远程服务",
    AlarmContact: "告警联系人",
    North: "北向三方",
    PrinterDriver: "驱动管理",
    HangingDevice: "打印机列表",
  },
  //表格组件
  TableComponent: {
    operating: "操作",
    edit: "编辑",
    delete: "删除",
    loading: "正在获取信息...",
    empty: "暂无数据",
    loadingFail: "数据加载失败",
    serialNumber: "序号",
  },
  //登录页
  login: {
    LoginTitle: "物联网云平台",
    userDisplay: "用户登录",
    user_isloggedin: "请输入用户名或邮箱",
    Password_By_Supervisor: "请输入密码",
    http_login: "立即登录",
    viewport: "用户名或密码错误,请检查后重新输入",
    password_short: "密码长度不能小于6位",
  },

  //路由
  router: {
    Dashboard: "首页",
    Index: "首页",
    Login: "物联网云平台",
    Gateone: "远程操作",
    Device: "设备管理",
    Particulars: "设备详情",
    DeviceList: "设备列表",
    CloudMonitorDeviceList: "设备列表",
    Unusuallist: "异常设备列表",
    GroupingList: "分组列表",
    AlarmMsg: "故障管理",
    Historywarn: "历史告警",
    Warnconfiguration: "告警配置",
    Currenttimewarn: "实时报警",
    Diagnosemessage: "诊断信息",
    Graphs: "统计报表",
    Onlinerate: "在线率",
    Flowstatistics: "流量统计",
    Signalstatistics: "信号统计",
    Softwareversion: "软件版本",
    Resource: "配置管理",
    Configurationlist: "设备配置",
    Firmware: "批量配置",
    Configuration: "配置列表",
    Task: "任务管理",
    Upgrade: "软件任务",
    Softwarepackage: "固件管理",
    System: "系统管理",
    Authoritymanagement: "安全管理",
    Customermanagement: "客户管理",
    Operationlog: "操作日志",
    Enterlog: "登录日志",
    Usercontrol: "用户管理",
    Parametermanagement: "参数管理",
    RemoteService: "远程服务",
    AlarmContact: "告警联系人",
    North: "北向三方",
    PrinterDriver: "驱动管理",
    HangingDevice: "打印机列表",
    /**
     * 云监测
     */
    FastAccess: "快速接入",
    MonitoringScreen: "监控大屏",
    ProjectGroup: "项目列表",
    TerminalList: "终端列表",
    CloudMonitorTerminalList: "终端列表",
    CollectConfigurate: "采集配置",
    EditCollection: "添加变量",
    AddDevice: "添加设备",
    AddTerminal: "添加终端",
    AlarmNotice: "报警通知",
    AlarmContact: "报警联系人",
    AlarmList: "报警记录",
    HistoryRecords: "历史记录",
    DevicesStatus: "设备上下线",
    variableList: "变量列表",
    logManagement: "日志管理",
  },
  //首页
  dashboard: {
    Equipment: "设备在线汇总",
    offline: "离线设备",
    online: "在线设备",
    form: "占比",
    summary: "设备数量汇总",
    chieffinancialofficer: "物联网关",
    Router: "路由器",
    PrintStream: "打印服务器",
    Serial: "串口服务器",
    Other: "其它",
    Serials: "序列号",
    name: "名称",
    ADDRESS: "地址",
    OfflineDevice: "离线设备",
    OnlineDevice: "在线设备",
    AllDevices: "所有设备",
    message1: "两次输入密码不一致",
    message2: "用户密码由任意数字、字符串、下划线组成，必须超过6位小于16位",
    message3: "修改成功",
    message4: "操作失败",
    message5: "不支持全屏",
    Amap: "高德地图",
    google: "谷歌地图",
    emailError: "请输入正确的邮箱",
    activateTips: "验证邮件已发送您的邮箱，请在30分钟内激活",
    userPWDError: "用户密码不正确",
    oldPWDError: "修改失败，旧密码不正确",
  },
  //首页头像内容
  user: {
    Personal: "个人资料",
    ChangePassword: "修改密码",
    exit: "退出",
    User: "用户名",
    NICKNAME_RE: "用户昵称",
    UserRelated: "用户姓名",
    Gender: "性别",
    Phones: "手机号码",
    social: "QQ/微信",
    Email: "邮箱地址",
    software: "用户地址",
    recently: "最近登录",
    modify: "修改",
    Male: "男",
    Female: "女",
    OldPassword: "旧密码",
    NewPassword: "新密码",
    Confirm: "确认密码",
    cancel: "取消",
    Confirmation: "确认",
    badconfirmstr: "确认修改",
    BindingEmail: "邮箱绑定",
    EmailAddress: "邮箱地址",
    VerifyPassword: "验证密码",
    Chinese: "简体中文",
    EmailBinding: "邮箱绑定",
  },
  // 个人资料
  //axios拦截提示
  http: {
    prompt: "提示",
    Text: "登录状态已过期，请重新登录!",
    Buttom: "重新登录",
  },
  //设备列表
  devicelist: {
    SerialNumber: "序号",
    Serial: "序列号",
    Equipment: "设备分组",
    DeviceName: "设备名称",
    IP: "IP地址",
    statevoid: "状态",
    traffic: "流量",
    signal: "信号强度",
    racingnetwork: "网络制式",
    XoopsOnlineHandler: "在线时长",
    TimeSeries: "上线/离线时间",
    Version: "软件版本",
    schemaLocation: "设备位置",
    Operation: "操作",
    Please: "请选择相关操作",
    restart: "重启设备",
    Factory: "恢复出厂设置",
    Backup: "备份配置文件",
    personsto: "获取设备日志",
    Timer: "定时重启",
    Prototype: "取消定时重启",
    reloadM2M: '重启M2M服务',
    batch_groups_path: "批量修改分组",
    batch: "不刷新",
    L5Nrefresh: "5秒刷新",
    L10Nrefresh: "10秒刷新",
    L20Nrefresh: "20秒刷新",
    L60Nrefresh: "60秒刷新",
    connected: "已连接",
    not: "未连接",
    Disconnect: "断开远程连接",
    changes: "修改分组",
    Primary: "一级分组",
    secondary: "二级分组",
    highlevel: "三级分组",
    PLEASE: "请选择",
    Choose: "不选",
    Determine: "确定",
    CancelTst: "取消",
    removed: "删除设备",
    message1: "删除成功",
    message2: "删除失败",
    message3: "未选中设备",
    message4: "修改成功",
    message5: "修改失败",
    message6: "当前选中有未在线的设备",
    message7: "该操作只允许单个设备操作",
    message8: "请选择设备再进行操作",
    message9: "连接成功",
    message10: "连接失败",
    message11: "正在建立连接",
    message12: "成功断开",
    message13: "操作失败",
    message14: "设备名不能为空",
    message15: "修改成功",
    message16: "修改失败",
    message17: "设备位置不能为空",
    search1: "序列号搜索",
    search2: "设备分组",
    search3: "设备名称",
    search4: "IP地址",
    search5: "状态",
    search6: "流量",
    search7: "信号",
    search8: "网络制式",
    search9: "在线时长",
    search10: "上线/离线时间",
    search11: "软件版本",
    search12: "设备位置",
    FirstLevelProject: "所属一级分组",
    SecondLevelProject: "所属二级分组",
    DeviceAddress: "设备地址",
    Name: "名称",
    connecttodevice: '连接到设备',
    Disconnect: '断开连接',
    disbad: "断开失败",
    WANPortTraffic: 'WAN口流量',
    _3GWAN1Traffic: '3G WAN1流量',
    _3GWAN2Traffic: '3G WAN2流量',
    repair: '确定要修复此设备吗？',
    progress: '执行中...',
    contactCustomerService: '执行成功，如设备任然存在异常，请联系客服!',
    Detection: '设备检测',
    confirmRepir: '确定要对所有可能有问题的设备进行检测与修复吗？',
    waitRun: '等待执行中...',
    noDeviceRepair: '暂无设备需要修复',
    total: '总数',
    success: '成功',
    fail: '失败',
  },
  gateone: {
    closeTips: "关闭提示",
    isUsed: "设备远程连接已经被使用",
    successConect: "连接成功",
    failConnect: "连接失败",
    connecting: "正在建立连接",
  },
  //设备远程操作组件
  Dialog: {
    affected: "受影响设备",
    cancel: "取消",
    Determine: "确定",
    translators: "选择时间",
    interface: "接口序号",
    prompt: "提示",
    Weltordnung: "获取成功",
    download: "立即下载",
    Monday: "周一",
    Tuesday: "周二",
    Wednesday: "周三",
    Thursday: "周四",
    Friday: "周五",
    saturday: "周六",
    sunday: "周日",
    Backup: "备份配置文件",
    personsto: "获取设备日志",
    SkinVector: "获取成功",
    allocator: "获取中",
    WaitForMultipleObjects: "获取失败",
    operation: "操作成功",
    BoxapiJSONOperation: "操作失败",
    remoteservice: "远程服务",
    executing: "正在执行，请勿重复操作!",
  },
  //设备详细信息
  particulars: {
    modify: "修改",
    Add: "添加远程服务",
    batch: "不刷新",
    L5Nrefresh: "5秒刷新",
    L10Nrefresh: "10秒刷新",
    L20Nrefresh: "20秒刷新",
    L60Nrefresh: "60秒刷新",
    WAD_NUMBER_RETURN: "返回",
    SystemUptime: "系统信息",
    DeviceName: "设备名称",
    Grouping: "设备分组",
    Professional: "系统名称",
    Models: "主机型号",
    Version: "软件版本",
    Kernel: "内核版本",
    Product: "产品型号",
    Serial: "序列号",
    Hardware: "硬件类型",
    hardware: "硬件版本",
    mac: "MAC地址",
    network: "网络模式",
    VendorModel: "厂商",
    deviceID: "设备ID",
    ADDRESS: "地址",
    detailed: "详细地址",
    UpgradeTime: "更新时间",
    Customer: "客户",
    StateManager: "状态信息",
    connection: "连接状态",
    foreach: "首次登录时间",
    CurTime: "在线总时长",
    beforeoffline: "离线总时长",
    TimeModeSetOffline: "本次离线时间",
    SCLocalTime: "本次离线时长",
    LoginTime: "本次登录时间",
    online_updated: "本次在线时长",
    NetworkTraffic: "网络流量",
    GeneralInfo: "概览",
    traffic: "今日流量",
    Monthly: "本月流量",
    software: "最近7天流量",
    addToTrafficDensityMap: "总流量",
    WAN: "有线广域网状态",
    IP: "IP地址",
    gateway: "网关",
    NonContiguousSubnetMask: "子网掩码",
    NETWORK: "网络协议",
    DNS1: "DNS1",
    DNS2: "DNS2",
    NETWORK_FAUX_QUEUE: "连接时长",
    Connection: "连接状态",
    UpdateTime: "更新时间",
    wan3g1: "移动网络状态（3gwan1）",
    wan3g2: "移动网络状态（3gwan2）",
    wan3g1Tag1: "移动网络状态（3gwan1云鹰卡）",
    wan3g1Tag2: "移动网络状态（3gwan2云鹰卡）",
    wan3g1IP: "IP地址",
    wan3g1IPV6: "IPV6地址",
    wan3g1gateway: "网关",
    wan3g1NonContiguousSubnetMask: "子网掩码",
    wan3g1NETWORK: "网络协议",
    wan3g1DNS1: "DNS1",
    wan3g1DNS2: "DNS2",
    MODULE_FILE_SUFFIX: "模块型号",
    Operator: "运营商",
    supported: "支持制式",
    IMSI: "IMSI",
    IMEI: "IMEI",
    ICCID: "ICCID",
    current: "当前网络制式",
    SignalStrengths: "信号强度",
    SIM: "SIM状态",
    wan3g1NETWORK_FAUX_QUEUE: "连接时长",
    wan3g1Connection: "连接状态",
    wan3g1UpdateTime: "更新时间",
    profile: "有线局域网状态",
    profileIp: "IP地址",
    profilegateway: "网关",
    profileNonContiguousSubnetMask: "子网掩码",
    profileNETWORK: "网络协议",
    profileConnection: "连接状态",
    profileUpdateTime: "更新时间",
    GPS: "GPS信息",
    long: "经度",
    lat: "纬度",
    service: "远程服务信息",
    YTCommunityTag: "社区名",
    password: "密码",
    YTCommuniIP: "IP",
    Operation: "操作",
    statusClear: "在线/离线时长清零",
    rthq_infobase: "基站信息",
    MNC: "MNC",
    MCC: "MCC",
    LocationListener: "位置信息",
    networkRemoveOk: "网络类型",
    unknown: "未知",
    connected: "已连接",
    not: "未连接",
    blendmode: "单模单卡",
    discard_year: "单模双卡",
    SerialServer: "串口服务器",
    PrintServer: "打印服务器",
    model_id: "双模双卡",
    MultiSimVariants: "多模多卡",
    Modeling: "有线模式",
    G3G4: "3G/4G模式",
    G4G5: "4G/5G模式",
    compatibility: "兼容模式",
    addressStrings: "静态地址",
    refreshHaves: "已插卡",
    info_normal_color: "未插卡",
    package_pin: "无pin码",
    IMEI_CODE_LEN: "无PUK码",
    aac_card_type: "卡异常",
    AtomServiceDualParser: "删除远程服务",
    si_modify: "修改",
    reset_type: "重置",
    Day: "天",
    hours: "小时",
    minutes: "分钟",
    seconds: "秒",
    GPSrequire: "(GPS上报)",
    Processmanagement: "系统服务",
    Processname: "服务名",
    Processstatus: "服务状态",
    Processcontrol: "服务控制",
    ProcessDate: "更新时间",
    Devicenotonline: "设备未在线",
    NotSupport: "设备不支持该功能",
    dropbear: "SSH访问",
    smartlink: "智慧物联",
    smartnms: "网管服务",
    uhttpd: "Web服务",
    loc: "定位服务",
    watchcat: "网络监控",
    "ss-redir": "链路聚合",
    configmgr: "配置服务",
    m2mMqtt: "m2mMqtt",
    watchfox: "4G监控",
    firewall: "防火墙",
    M2MProxy: "M2M平台",
    smartm2m: 'M2M平台',
    mwan3: "负载均衡",
    socat: "中继器",
    smartcat: "中继器",
    smartant: "管理服务",
    openvpn: "OpenVPN",
    repeater: "中继器",
    IOControl: "IO控制",
    ipsec: "IPSec",
    eoip: "EOIP",
    pptp1: "PPTP",
    gre1: "GRE",
    wlan0: "WIFI",
    l2tp1: "L2TP",
    Running: "运行中",
    Stop: "停止",
    startup: "启动",
    Restart: "重启",
    operation: "操作成功",
    BoxapiJSONOperation: "操作失败",
    message1: "当前设备未在线",
    message2: "此操作将给该设备添加远程服务",
    message3: "提示",
    message4: "确定",
    message5: "取消",
    message6: "添加成功",
    message7: "添加失败",
    message8: "取消添加",
    message9: "当前设备未在线",
    message10: "此操作将删除该设备远程服务",
    message11: "删除成功",
    message12: "删除失败",
    message13: "取消删除",
    message14: "确定修改设备经度为",
    message15: "修改成功",
    message16: "修改失败",
    message17: "纬度为",
    wan2: "移动网络状态（3gwan2）",
    wirelessWifi: "无线wwan网络",
    networkStatus: "网络状态",
    disOpened: "未启用",
    trafficClear: "流量清零",
    hanging: "下挂设备",
    OnlineTimes: "上线次数",
    OfflineTimes: "下线次数",
    networkMonitoring: "网络监控",
    frpc: 'frpc服务'
  },
  // 无线网路
  wireless: {
    interfaceName: "接口名",
    interfaceStatus: "接口状态",
    running: "运行中",
    stop: "停止",
    ip: "IP地址",
    subnetMask: "子网掩码",
    gateway: "网关地址",
    protocol: "协议",
    DNSServer: "DNS服务",
    hops: "跃点",
    connectTime: "连接时长",
    uplink: "上行流量",
    downlink: "下行流量",
  },
  //分组管理
  groupinglist: {
    maskbitInput: '请输入掩码位',
    GroupName: "分组名称",
    GroupByTests: "上级分组",
    belonging: "归属客户",
    contact_to: "归属用户",
    Creator: "创建者",
    services: "服务类型",
    account_root: "远程账号",
    RemoteMailboxes: "远程密码",
    IPaux: "远程IP",
    Update: "更新时间",
    Operation: "操作",
    Add: "添加",
    Migrate: "迁移",
    MigrationGroup: "迁移分组",
    N2nVersion: "版本",
    port: "端口",
    loadData: "添加分组",
    optional_groups: "修改分组",
    group1: "一级分组",
    group2: "二级分组",
    AllowMultipleLogins: "允许多处登录",
    DonotAllowmultiplelogins: "不允许多处登录",
    cancel: "取消",
    Determine: "确定",
    GroupDef_delete: "删除分组",
    message1: "长度为大于6位小于18位",
    message2: "远程密码必须大于6位小于18位",
    message3: "远程ip输入有误，请检查",
    message4: "修改成功",
    message5: "组名重复",
    message6: "远程账号名重复",
    message7: "分组下存在设备，无法删除",
    message8: "操作失败",
    message9: "请添加远程账号信息",
    message10: "默认分组无法被删除",
    message11: "删除成功",
    message12: "删除失败",
    message13: "添加成功",
    message14: "操作失败",
    message15: "迁移成功",
    message16: "迁移失败",
    message17: "请选择分组",
    platformprint: "远程打印",
    ReconStandardServicePanel: "标准服务",
    Standard: "必填",
    Optional: "选填",
    selector: "请选择",
    Choose: "不选",
    search1: "分组名称",
    search2: "上级分组",
    search3: "归属客户",
    search4: "创建者",
    search5: "服务类型",
    search6: "远程账号",
    search7: "远程密码",
    search8: "远程IP",
    search9: "更新时间",
    search10: "归属用户",
    userpwdChineseCheck: "账号、密码不能包含中文",
    notEmpty: "不能为空",
    ipInput: "请输入远程IP",
    groupNameInput: "请输入分组名称",
    firstLevelGrouping: "一级分组",
    secondaryGrouping: "二级分组",
    threelevelgrouping: "三级分组",
    GroupingLevel: "分组级别",
    mobileGrouping: "移动分组",
    bridging: "桥接",
    // 远程桥接
    remoteBridge: "远程桥接",
    // 桥接提示
    bridgePrompt: "勾选桥接时，远程IP地址将被设置为和网关LAN IP默认地址一样（192.168.1.1），此时Superlink网络可以用本地局域网方式访问网关LAN下挂终端。",
    bridgePrompt2: "取消勾选桥接时，远程IP地址将被还原为默认的IP地址（172.16.100.2）。此时Superlink网络将以远程跨网段方式访问网关LAN下挂终端。",
    // 桥接提示
    bridgePrompt3: "该远程服务版本不支持桥接",
    serverFeatures: "服务器原则功能特性",
  },
  //异常设备列表
  unusuallist: {
    Serial: "序列号",
    DeviceName: "设备名称",
    Version: "软件版本",
    DeleteTime: "删除时间",
    Operation: "操作",
    prompt: "提示",
    Tetx: "将设备恢复到设备列表中, 是否继续?",
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    success: "恢复成功",
    RestoreMetaData: "恢复失败",
    search1: "输入序列号",
    search2: "输入设备名称",
    search3: "输入软件版本",
    search4: "输入删除时间",
  },
  //配置列表
  configuration: {
    createFile: "文件名称",
    ntfs_file_open: "文件大小(KB)",
    heir_do: "上传人",
    Upload: "上传时间",
    noteId: "备注",
    Operation: "操作",
    Add: "添加",
    Configuration: "添加配置文件",
    add_action: "点击上传",
    file_name: "文件格式必须为.tar.gz",
    uploaders: "上传",
    modifycollection: "修改配置文件",
    justUploaded: "上传成功",
    successfully: "上传失败",
    TestDelete: "删除成功",
    bdb_delete: "删除失败",
    m_pr_modifyS: "修改成功",
    onCallModifying: "修改失败",
    t_config_file: "删除配置文件",
    databases: "此操作将永久删除该数据, 是否继续?",
    Determine: "确定",
    cancel: "取消",
    Optional: "选填",
    search1: "请输入文件名称",
    search2: "请输入文件大小",
    search3: "请输入上传人",
    search4: "请输入上传时间",
    search5: "请输入备注",
  },
  //设备配置
  ConfigSetting: {
    successSetting: "配置成功",
    failSetting: "配置失败",
    L2TP: "L2TP",
    PPTP: "PPTP",
    bandwidth: "频宽",
    channel: "信道",
    GroupSelection: "分组选择",
    Searchgroup: "搜索分组",
    DeviceSelection: "设备选择",
    pleaseChoose: "请选择",
    Protocol: "协议",
    Staticaddress: "静态地址",
    DHCPclient: "DHCP 客户端",
    IPv4address: "IPv4 地址",
    IPv4netmask: "IPv4 子网掩码",
    UsecustomDNSservers: "使用自定义的DNS 服务器",
    SaveApply: "保存并应用",
    DHCP: "请求 DHCP 时发送的主机名",
    IPv4gateway: "IPv4网关",
    NetworkType: "网络类型",
    Automatic: "自动",
    PAPCHAPusername: "PAP/CHAP 用户名",
    PAPCHAPpassword: "PAP/CHAP 密码",
    custom: "自定义",
    AuthenticationType: "认证类型",
    ICMPCheck: "ICMP 检测",
    Disable: "禁用",
    Enable: "开启",
    ServiceType: "服务类型",
    Dialnumber: "拨号",
    LocalIPAddress: "本地接口ip地址",
    Hostname: "主机名",
    Timezone: "时区",
    Language: "语言",
    WANMode: "WAN模式",
    andWired: "兼容模式",
    Wired: "有线模式",
    G3G4: "3G/4G模式",
    G4G5: "4G/5G模式",
    NTPclient: "启用 NTP 客户端",
    NTPserver: "作为 NTP 服务器提供服务",
    servercandidates: "候选 NTP 服务器",
    WebAccess: "Web访问",
    Changes: "修改访问Web控制台的端口",
    Port: "端口",
    SSHAccess: "SSH访问",
    Dropbear: "Dropbear 提供 SSH 访问和 SCP 服务",
    Interface: "接口",
    unspecified: "未指定",
    Passwordauthentication: "密码验证",
    withpassword: "允许 root 用户凭密码登录",
    Gatewayports: "网关端口",
    ADD: "添加",
    protection: "SYN-flood 防御",
    Dropinvalidpackets: "无效数据包",
    Input: "入站数据",
    Output: "出站数据",
    Forward: "转发",
    accept: "接受",
    drop: "丢弃",
    reject: "拒绝",
    ModeUrl: "域名过滤",
    Disables: "禁用",
    while: "白名单",
    black: "黑名单",
    Domain: "域名",
    Name: "名字",
    Externalzone: "外部区域",
    ExternalIPaddress: "外部端口",
    Internalzone: "内部区域",
    InternalIPaddress: "内部端口",
    operating: "操作",
    delete: "删除",
    Other: "其它",
    DISABLE: "禁用",
    DEABLE: "开启",
    SourceIPaddress: "源IP地址",
    Rule: "规则",
    ExternalIPaddress: "外部IP地址",
    InternalIPaddress: "内部IP地址",
    Sourceport: "源端口",
    EnableNATLoopback: "启用NAT环回",
    Extraarguments: "附加参数",
    edit: "编辑",
    cancel: "取消",
    determine: "确定",
    Ststem: "系统",
    Administration: "管理权",
    Firewall: "防火墙",
    DomainFilter: "域名过滤",
    KeywordFilter: "关键字过滤",
    PortForwards: "端口转发",
    M2MPlatform: "M2M平台",
    StartM2MPlatformControl: "启用M2M平台管理",
    HeartbeatInterval: "心跳包上报频率(秒)",
    Heartbeattimeouttimes: "心跳包失败次数",
    reportingFrequency: "定位数据上报频率(秒)",
    NetStatusInterval: "网络状态上报频率(秒)",
    ServerIP: "服务器IP地址",
    Successfulconfiguration: "配置成功",
    Configurationerror: "配置错误",
    Nochangesmade: "未做出修改",
    Pleasecheck: "请检查输入内容",
    BasicSettings: "基本设置",
    WirelessNetwork: "无线网络",
    Mode: "模式",
    HideESSID: "隐藏ESSID",
    WMMMode: "WMM模式",
    WirelessSecurity: "无线安全",
    Encryption: "加密方式",
    Key: "密钥",
    AccesspointAP: "接入点AP",
    wifimessage: "wifi密钥长度至少为8位",
    OnOff: "启动/关闭",
    L2TPServer: "L2TP服务器",
    PapchapUsername: "PAP/CHAP用户名",
    PapchapPassword: "PAP/CHAP密码",
    PowerOn: "开机自启",
    UseDefaultGateway: "使用默认网关",
    LCPResponseFailureThreshold: "LCP 响应故障阈值",
    LCPResponseInterval: "LCP 响应间隔",
    AdditionalPPPParameters: "额外的PPP参数",
    VpnServer: "VPN 服务器",
    MPPEEncryption: "MPPE加密方式",
    Smartlink: "智慧物联",
    smartnms: "网管服务",
    PortalAuthentication: "门户认证",
    Enable: "启用",
    isEnable: "已启用",
    disEnable: "已禁用",
    Address: "地址",
    PageUpdate: "页面更新",
    JumpAddressAfterAuthentication: "认证后跳转地址",
    SessionTimeout: "会话超时",
    MaximumNumberOfCustomers: "最大客户数",
    UncertifiedEquipment: "未认证设备",
    CertifiedEquipment: "已认证设备",
    AuthenticationFreeMACAddress: "免认证设备MAC地址",
    IgnoreWiredDevices: "忽略有线设备",
    debug: "调试",
    not: "无",
    error: "错误",
    information: "信息",
    basicConfiguration: "基本配置",
    redirect: "通信规则",
    name: "名称",
    protocols: "协议",
    TCP: "TCP",
    TCP_UDP: "TCP+UDP",
    UDP: "UDP",
    ICMP: "ICMP",
    anyone: "任何",
    custom: "--自定义--",
    pleaseInput: "请输入",
    SRC: "源区域",
    SRCIp: "源IP地址",
    dest: "目标区域",
    dest_ip: "目标IP地址",
    SNAT: "SNAT IP地址",
    anyoneDest: "任意区域",
    deviceSelectTips: "仅展示联网在线的设备列表",
    SNSearch: "根据SN筛选",
    filter: "过滤",
    interfaceSetting: "接口配置",
    deiveceSetting: "设备配置",
    trandform: "WAN转LAN",
    disabled: '已禁用',
    UseGatewayHops: '使用网关跃点',
    useTheDns: '使用对端通告的 DNS 服务器',
    activityTimeout: '活动超时',
    resetMTU: '重设 MTU',
    useTheCustomDns: '使用自定义的 DNS 服务器',
    GetIPv6address: '获取 IPv6 地址',
    IPSecConfiguration: 'IPSec配置',
    L2TPKey: 'L2TP 密钥',
    optional: '可选',
    SIMmode: 'SIM卡模式:',
    Dualcardbackup: '双卡备份:',
    SIM1APNaccesspoint: 'SIM1 APN接入点:',
    SIM1username: 'SIM1 用户名:',
    SIM1password: 'SIM1 密码:',
    SIM1authenticationtype: 'SIM1 认证类型:',
    SIM1carriermode: 'SIM1 运营商模式:',
    SIM1IPprotocol: 'SIM1 IP协议:',
    ChinaMobile: '中国移动',
    ChinaUnicom: '中国联通',
    ChinaTelecom: '中国电信',
    SIM1localIPaddress: 'SIM1 本地IP地址:',
    SIM1PINcode: 'SIM1 PIN码:',
    SIM1cardtype: 'SIM1 卡类型:',
    publicnetworkcard: '公网卡',
    privatenetworkcard: '专网卡',
    SIM1detectionstrategy: 'SIM1 检测策略',
    RSSIsignal: 'RSSI信号',
    Pingdelay: 'Ping延迟',
    mixedstrategy: '混合策略',
    SIM1RSSIThreshold: 'SIM1 RSSI阈值:',
    SIM1LatencyThreshold: 'SIM1 延迟阈值:',
    scope1: "当RSSI值低于阈值时，则判断拨号连接为已中断。取值范围(0,30)",
    scope2: '当Ping检测延迟超过阈值时，则判断拨号连接已中断。单位为毫秒。取值范围(100,3000)',
    SIM1detectionaddress: 'SIM1 检测地址:',
    SIM1detectioncycle: 'SIM1 检测周期:',
    scope3: '检测网络连接的频率,单位为秒',
    SIM1PingCount: 'SIM1 Ping次数:',
    SIM2APNaccesspoint: 'SIM2 APN接入点:',
    SIM2username: 'SIM2 用户名:',
    SIM2password: 'SIM2 密码:',
    SIM2authenticationtype: 'SIM2 认证类型:',
    SIM2carriermode: 'SIM2 运营商模式:',
    SIM2localIPaddress: 'SIM2 本地IP地址:',
    SIM2PINcode: 'SIM2 PIN码:',
    SIM2cardtype: 'SIM2 卡类型:',
    SIM2detectionstrategy: 'SIM2 检测策略',
    SIM2RSSIThreshold: 'SIM2 RSSI阈值:',
    SIM2LatencyThreshold: 'SIM2 延迟阈值:',
    SIM2detectionaddress: 'SIM2 检测地址:',
    SIM2detectioncycle: 'SIM2 检测周期:',
    SIM2PingCount: 'SIM2 Ping次数:',
    Restartafternetworkdisconnection: '断网重启:',
    AlibabaCloudEagleCard: '阿里云鹰卡:',
    defaultcarrier: '默认运营商:',
    disabledAccess: '默认禁止Wan Web访问：',
    SIMDefaultConfig: 'SIM默认配置',
    enable2: '已启用',
    server: '服务器地址',
    upgrade: 'v3平台侧有可拉取固件',
    mqttQos: 'v3MQTT服务质量',
    mqttAlive: 'v3MQTT保活周期',
    status: '状态',
    sercerOk: "服务器连通性检测",
    v2tcpServer: 'V2_TCP连接',
    v2mqttServer: 'V2_MQTT连接'
  },
  // 设备配置-> 有线网络
  wire: {
    wireNetwork: "有线网络",
    normalSetting: "一般配置",
    functionConfiguration: "功能配置",
    DHCPServer: "DHCP服务器",
    ignoreInterface: "忽略此接口",
    ignoreTips: "不在此接口提供DHCP服务。",
    start: "开始",
    startTips: "网络地址的起始分配基址。",
    customerNum: "客户数",
    customerNumTips: "最大地址分配数量。",
    leaseTerm: "租期",
    leaseTermTips: "租用地址的到期时间，最短2分钟（2m）。",
    DHCPOptions: "DHCP选项",
    DHCPOptionsTips:
      '设置DHCP的附加选项，例如设定 "6,114.114.114.114" 表示通告不同的 DNS 服务器给客户端。',
    DHCP: "DHCP客户端",
    changeProtocol: "切换协议",
    confirmChange: "确定要切换协议？",
    hostname: "请求DHCP时发送的主机名",
  },
  // 设备配置-> 移动网络
  mobile: {
    mobileNetwork: "移动网络",
  },
  // 设备配置-> 防火墙
  firewall: {
    addNAt: "新建Source NAT",
    name: "名称",
    protocal: "协议",
    protocalTips:
      "您也可以选择“--自定义--”来定义多个协议，在多个协议间需加空格。",
    sourceArea: "源区域",
    sourceIp: "源IP地址",
    targetArea: "目标区域",
    targetIp: "目标IP地址",
    SNATIp: "SNAT IP地址",
    SNATIpTips: "将匹配流量的源地址改写成指定地址。",
    additonalParameters: "附加参数",
    additonalParametersTips: "传递到 iptables 的额外参数。小心使用！",
    all: "所有",
  },
  // 设备配置-> 端口转发
  port: {
    portForwards: "端口转发",
    outerPort: "外部端口",
    innnerPort: "内部端口",
    enable: "开启",
    addPortForwards: "新建端口转发",
    other: "其他",
    addTips: "你有未填写的选项，是否确认忽略并添加？",
    tips: "提示",
    innerPort: "内部端口",
  },
  // 设备配置-> smartlink
  smartlink: {
    general: "通用",
    modeConfiguration: "模式配置",
    enable: "启用",
    uplink: "上行设备",
    downlink: "下行设备",
    connectConfiguraton: "连接配置",
    serialPort: "串口配置",
    interface: "接口",
    baudRate: "波特率",
    dataBits: "数据位",
    stopBits: "停止位",
    checkBits: "校验位",
    flowControl: "流控",
    senior: "高级",
    enableSubcontracting: "启用分包",
    subcontractingInterval: "分包间隔",
    subcontractingIntervalTips: "毫秒",
    subcontractingLength: "分包长度",
    subcontractingLengthTips: "字节",
    name: "名称",
    workingMode: "工作模式",
    targetAddress: "目标地址",
    status: "状态",
    connected: "已连接",
    listening: "已侦听",
    partialConnected: "部分连接",
    unknown: "未知",
    disconnect: "未连接",
    connectNumber: "连接数",
    protocal: "协议",
    listenPort: "监听端口",
    serverAddress: "服务器地址",
    serverTips: "地址:端口",
    serverError: "地址输入有误",
    platformName: "平台名称",
    DTUNumber: "DTU编号",
    corporateLogo: "企业标志",
    deviceType: "设备类型",
    encyptionKey: "加密密钥",
    GPSLogitude: "GPS经度",
    GPSLatitude: "GPS纬度",
    keyTime: "密钥时间",
    deviceNumberPrefix: "设备编号前缀",
    messagePrefix: "消息前缀",
    messagePrefixTips: "以0x或0X开头的标准十六进制串，最大4个字节",
    messageLength: "消息长度域字节",
    messageLengthTips: "字节",
    messageSequenceNumber: "消息序列号",
    deviceID: "设备ID",
    deviceIDTips:
      "可支持ASCII和十六进制串。若为十六进制串，则必须是已0x或0X开头的标准十六进制串，且最大长度为16字节",
    CRCCheck: "CRC校验",
    messageSuffix: "消息后缀",
    deviceName: "设备名称",
    username: "用户名",
    password: "密码",
    subscribeTopics: "订阅主题",
    reportingSubject: "上报主题",
    customerId: "客户ID",
    MqttSurvivalCycel: "MQTT保活周期",
    enableHearbeat: "启用心跳",
    heartbeatInterval: "心跳间隔",
    heartbeatIntervalTips: "秒",
    heartbeatContent: "心跳内容",
    heartbeatContentTips:
      "可支持ASCII和十六进制串。若为十六进制串，则必须是已0x或0X开头的标准十六进制串，且最大长度为64字节",
    debug: "调试",
    TCPSurvivalFreeTime: "TCP保活空闲时长",
    TCPSurvivalDetectionInterval: "TCP保活探测间隔",
    TCPSurvivalDetectionMax: "TCP保活探测最大次数",
    saveLogNumber: "保留日志文件个数",
    logSize: "日志文件大小",
    download: "下载",
    log: "日志文件",
    logPriority: "日志优先级",
    pleaseChoose: "请选择",
    TCPServer: "TCP服务端",
    TCPClient: "TCP客户端",
    UDPServer: "UDP服务端",
    UDPClient: "UDP客户端",
    RealCom: "实串口模式",
    MQTTClient: "MQTT客户端",
    UART: "通用串口",
    PassThrough: "透传模式",
    ModbusJSON: "Modbus JSON",
    ModbusRTU: "Modbus RTU",
    FourGDTU: "4G DTU", // 广东质安
    SCTCOEM: "深圳建委协议", // 广东质安
    Custom: "自定义",
    CYKJOEM: "超友科技", // 超友科技
    SHIERYEOEM: "中国二十冶集团", // 中国二十冶集团有限公司
    EHBOEM: "广东E环保", // 广东E环保
    msgError: "必须以0x或者0X为前缀",
    nameError: "请输入名称",
    seconds: "秒",
    info: "信息",
    notice: "注意",
    alarm: "警告",
    error: "错误",
    deadly: "致命",
    alert: "警戒",
    emergency: "紧急",
    modbusTCPMain: "Modbus TCP主站",
    modbusTCPFollow: "Modbus TCP从站",
    modbusRTUMain: "Modbus RTU主站",
    modbusRTUFollow: "Modbus RTU从站",
    slaveAddrees: "从站地址",
    slavePort: "从站端口",
    slaveID: "从站ID",
    sync_local_data: '同步本地数据',
    slaveIDTips: "同步本地采集指令中的数据",
    syncTips: '同步本地采集指令中的数据',
    responeTimeout: "响应超时",
    ms: "毫秒",
    byteInterval: "字节间隔",
    resendTimes: '重试次数',
    modbusDebug: "Modbus调试开关",
    localServer: "本地服务",
    subid: "设备Id",
    AIOT: "阿里云物联网平台",
    UDSServer: "UDS服务器",
    instanceId: "实例ID",
    productKey: "产品密钥",
    deviceName: "  设备名称",
    deviceSecret: "设备密钥",
    uploadInter: "上报周期",
    snmpVersion: "SNMP版本",
    snmpGroupName: "SNMP读写分组名称",
    udsServerPath: "服务器地址",
    collection: '采集',
    resendError: '取值范围: 0 ~ 5',
    ModbusASCIIMaster: 'Modbus ASCII主站',
    ModbusASCIIslave: 'Modbus ASCII从站',
    s7Client: 'S7 客户端',
    rackNumber: '机架号',
    s7_slot: '槽位',
    CollectionCycle: '采集周期',
  },
  // 设备配置 -> wifi
  wifi: {
    auto: "自动",
    CCMP: "强制 CCMP（AES）",
    TKIP: "强制 TKIP",
    CCMP_TKIP: "强制 TKIP 和 CCMP（AES）",
    static: "静态地址",
  },
  // 设备配置-> 网络接口信息
  network: {
    networkInfo: "网络接口基本信息",
    interfaceName: "接口名",
    enableStatus: "启用状态",
    enabled: "已启用",
    disable: "未启用",
    ipAddress: "IP地址",
    subnetMask: "子网掩码",
    gateway: "网关地址",
    protocal: "协议",
    connectTime: "连接时长",
    DNSServer: "DNS服务",
    hops: "跃点",
    upstreamTraffic: "上行流量",
    downstreamTraffic: "下行流量",
    staticAddress: "静态地址",
  },
  // 设备配置-> L2TP,pptp
  L2TP: {
    routeTips: "留空则不配置默认路由",
    LcpOneTips: "在指定数量的LCP响应故障后假定链路已断开，0为忽略故障",
    LcpTwoTips: "定时发送 LCP 响应（秒），仅在结合了故障阈值时有效",
    assignedAddress: "手动指派地址",
    assignedAddressError: "指派地址格式不正确",
    ipTips: "本地IP:远程IP",
  },

  // 请求
  request: {
    timeout: "请求超时，请重试",
    smartlinkError: "请求超时，请检查设备！",
  },
  //批量配置
  firmware: {
    hFirstTask: "创建任务",
    equipment: "设备",
    multitasking: "任务名",
    VI_Task: "任务描述",
    AsyncOperationStatus: "任务完成状态",
    createFile: "文件名",
    timerfunction: "更新时间",
    Operation: "操作",
    configuration: "添加批量配置任务",
    Equipment: "可操作设备",
    file: "文件",
    group1: "一级分组",
    group2: "二级分组",
    group3: "三级分组",
    cancel: "取消",
    Determine: "确定",
    $_blacklistedScalarArgsCallback: "创建任务成功",
    commands: "命令发送成功",
    connection: "远程连接成功",
    define: "下载中",
    DownloadEventNotifier: "下载完成",
    upgrading: "升级中",
    upgrade_drush_command: "升级完成",
    username_last_used: "用户名或密码错误",
    tempfile: "404文件不存在",
    Translators: "连接超时，无法下载",
    zxid_add_name_field: "解析域名错误",
    DOWNLOADER_CLIENT_TLS_METHOD: "下载超时",
    boolCheckPingURI: "MD5校验失败",
    upgrade_alter_tables: "升级失败",
    keymaster_error_t: "升级失败，未知错误",
    handle_remote_sigint: "远程连接失败",
    BAG_FILTER_EQUIPMENT: "设备已下线，稍后重试",
    m_upgradeThread: "升级包校验失败",
    TestDelete: "删除成功",
    intbdb_delete: "删除失败",
    CompositeTask: "删除任务",
    MissionAccomplished: "完成任务",
    Ongoing: "正在进行",
    search1: "输入任务名",
    search2: "输入任务描述",
    search3: "输入任务完成状态",
    search4: "输入文件名",
    search5: "输入更新时间",
  },
  ReportManagement: {
    Rates: "在线率",
    Units: "单位",
    signals: "信号值",
    number: "设备数",
    Version: "软件版本",
    datatype: "暂无数据",
    setPrompt: "提示",
    Determine: "确定",
  },
  //统计日期组件
  DateSelect: {
    StatisticType: "统计类型",
    year: "年",
    month: "月份",
    data: "日期",
    hour: "小时",
    minute: "分钟",
    Group1: "一级",
    Group2: "二级",
    Group3: "三级",
    Device: "设备",
    luaall_c: "全部",
    Statistical: "统计",
    PleaseChoose: "请选择",
    message1: "请选择分组",
    message2: "请选择设备",
    message3: "请选择年份",
    message4: "请选择月份",
    message5: "请选择日期",
    message6: "请选择小时",
    singleMonth: "月",
    singleDate: "号",
    singlehour: "时",
    singleminute: "分",
    st: "号",
    rd: "号",
    nd: "号",
    th: "号",
  },
  // 月份中文
  month: {
    "1": "1月",
    "2": "2月",
    "3": "3月",
    "4": "4月",
    "5": "5月",
    "6": "6月",
    "7": "7月",
    "8": "8月",
    "9": "9月",
    "10": "10月",
    "11": "11月",
    "12": "12月",
  },
  //固件管理
  softwarepackage: {
    Software: "软件名称",
    Version: "软件版本",
    types: "软件类型",
    SoftwareSize: "软件大小(KB)",
    adminhelpuploadusers: "上传用户",
    m_UploadOMeter: "上传时间",
    SynchronizationStatus: "同步状态",
    Operation: "操作",
    Add: "添加",
    addVarCopy: "添加包",
    add_action: "点击上传",
    file_name: "文件格式必须为.tar.gz",
    uploaders: "上传",
    Modify: "修改包",
    FirmwareAuthority: "固件权限",
    VisibleUser: "可见用户",
    DesignatedCustomer: "指定客户",
    AllUsers: "所有用户",
    SystemAdministrator: "系统管理员",
    Cancel: "取消",
    Confirm: "确定",
    SuccessfullyModified: "修改成功",
    onCallModifying: "修改失败",
    Pleaseselectacustomer: "请选择指定客户",
    PLEASE: "请选择",
    justUploaded: "上传成功",
    successfully: "上传失败",
    TestDelete: "删除成功",
    bdb_delete: "删除失败",
    remove_pkg: "删除软件包",
    search1: "请输入软件名称",
    search2: "请输入软件版本",
    search3: "请输入软件类型",
    search4: "请输入软件大小",
    search5: "请输入与上传用户",
    search6: "请输入上传时间",
    search7: "请输入同步状态",
    UpgradePackage: "升级包",
    PatchPackage: "补丁包",
    OrdinaryFile: "普通文件",
    Synced: "已同步",
    NotSynchronized: "未同步",
  },
  //软件任务
  upgrade: {
    equipment: "设备",
    FutureTask: "任务名",
    TaskStatus: "任务描述",
    addDistributionPackages: "添加升级任务",
    completion: "任务完成状态",
    createFile: "文件名",
    UPDATE_TO: "更新时间",
    Operation: "操作",
    hFirstTask: "创建任务",
    group1: "一级分组",
    group2: "二级分组",
    group3: "三级分组",
    adding: "添加升级任务",
    Equipment: "可操作设备",
    file: "文件",
    upgrades: "保留配置升级",
    Dont: "不保留",
    cancel: "取消",
    Determine: "确定",
    $_blacklistedScalarArgsCallback: "创建任务成功",
    commands: "命令发送成功",
    connection: "远程连接成功",
    define: "下载中",
    DownloadEventNotifier: "下载完成",
    upgrading: "升级中",
    upgrade_drush_command: "升级完成",
    username_last_used: "用户名或密码错误",
    tempfile: "404文件不存在",
    Translators: "连接超时，无法下载",
    zxid_add_name_field: "解析域名错误",
    DOWNLOADER_CLIENT_TLS_METHOD: "下载超时",
    boolCheckPingURI: "MD5校验失败",
    upgrade_alter_tables: "升级失败,文件格式错误",
    keymaster_error_t: "升级失败，未知错误",
    handle_remote_sigint: "远程连接失败",
    BAG_FILTER_EQUIPMENT: "设备已下线，稍后重试",
    TestDelete: "删除成功",
    bdb_delete: "删除失败",
    CompositeTask: "删除任务",
    search1: "输入任务名",
    search2: "输入任务描述",
    search3: "输入任务完成状态",
    search4: "输入文件名",
    search5: "输入更新时间",
    KeepConfiguration: "保留配置",
    Keep: "保留",
    TaskType: "任务类型",
    UpgradeTask: "升级任务",
    PatchTask: "补丁任务",
    StartingTime: "开始时间",
    MissionDetails: "任务描述",
    FileServer: "文件服务器",
    MissionAccomplished: "完成任务",
    Ongoing: "正在进行",
    SerialNumber: "序号",
    BackupServer: "备份服务器",
    DefaultServer: "默认服务器",
    PrimaryServer: "主服务器",
    checkSerialNumber: "请检查序列号是否有误",
    selectDevice: "请选择设备",
    normalTask: "普通任务",
    Version_NOT_SURPPORT: "版本不支持，请升级设备到最新版本",
    unknownError: "未知错误",
  },
  //任务组件
  taskDialog: {
    FutureTask: "任务名",
    TaskStatus: "任务描述",
    completion: "任务完成状态",
    group1: "一级分组",
    group2: "二级分组",
    group3: "三级分组",
    Equipment: "可操作设备",
    cancel: "取消",
    Determine: "确定",
    please: "请选择设备",
    File_Upload_Upgrader: "请选择升级文件",
    Dispatched: "操作成功",
    operation: "操作失败",
    file: "文件",
    provide: "请输入任务名",
    reassign_task_to: "请输入任务描述",
    fileServer: "文件服务器",
    TaskType: "任务类型",
    fileType: "文件类型",
    fileSize: "文件大小",
    deviceList: "设备待选列表",
    deviceChecked: "设备选中列表",
    confirmCreate: "确认创建任务",
    upgradeFile: "升级文件",
    filename: "文件名",
    toUpgrade: "待升级列表",
    filter: "输入序列号进行过滤",
  },
  //权限管理
  Authoritymanagement: {
    Add: "添加",
    Character: "角色名称",
    describe: "描述",
    statevoid: "状态",
    Creator: "创建者",
    belonging: "归属客户",
    Creation: "创建时间",
    Operation: "操作",
    hidden: "隐藏",
    show: "显示",
    DEFINED_RIGHTS: "权限管理",
    ANSI_PADDING: "添加角色",
    Description: "角色描述",
    cancel: "取消",
    Determine: "确定",
    mandatory: "权限分配",
    functionname: "功能名称",
    m_pr_modifyS: "修改成功",
    onCallModifying: "修改失败",
    deleteDir: "删除成功",
    intbdb_delete: "删除失败",
    Authorization: "请选择角色权限",
    localSuccess: "新增成功",
    NewNextNotifyDT: "新增失败",
    BoxapiJSONOperation: "操作失败",
    User_Role_Editor: "模板角色无法修改",
    addinganewrole: "删除角色",
    normal: "正常",
    Executing: "请输入添加的角色名称",
    l_vinformupdate: "请输入添加的角色描述",
    search1: "输入角色名称",
    search2: "输入描述",
    search3: "输入状态分类",
    search4: "输入创建者名称",
    search5: "输入归属客户名称",
    search6: "输入创建时间",
    deviceManagement: "设备管理"
    // SuperAdministratorRoleTemplate:'超级管理员角色模板',
    // CustomerAdministratorRoleTemplate:'客户管理员角色模板',
    // OrdinaryUserRoleTemplate:'普通用户角色模板',
    // RoleTemplate:'角色模板'
  },
  //客户管理
  customermanagement: {
    Add: "添加",
    customerName: "客户名称",
    Customer: "客户ID",
    Admin: "管理员",
    Contact: "联系人",
    phone: "联系电话",
    Email: "邮箱",
    detailed: "详细地址",
    services: "服务类型",
    Operation: "操作",
    userDisplay: "用户角色",
    HomeThis: "主页",
    ADDRESS: "地址",
    cancel: "取消",
    Determine: "确定",
    news: "新增客户",
    CustomerAttributes: "修改客户信息",
    message1: "添加成功",
    message2: "权限不足，添加失败",
    message3: "用户已存在，添加失败",
    message4: "客户已存在，添加失败",
    message5: "邮箱已被注册，添加失败",
    message6: "手机号码已被注册，添加失败",
    message7: "名称重复，添加失败",
    message8: "添加失败",
    message9: "删除成功",
    message10: "删除失败,该客户不能被删除",
    message11: "删除失败",
    message12: "修改成功",
    message13: "修改失败",
    errmessage1: "客户名称为必填项",
    errmessage2: "请选择用户角色",
    Mage_Customer: "删除客户",
    Mandatory: "必填",
    specifiedwill: "必选",
    Optional: "选填",
    ServiceClient: "标准服务",
    PrintCore: "远程打印",
    search1: "客户名称搜索",
    search2: "客户ID搜索",
    search3: "管理员搜索",
    search4: "联系人搜索",
    search5: "联系电话",
    search6: "邮箱",
    search7: "详细地址",
    search8: "服务类型",
    inputName: "请输入客户名称",
    selectRole: "请选择用户角色",
    notEdit: "未作出修改！",
    imgFormate: "上传头像图片只能是 JPG或PNG 格式!",
    imgSize: "上传头像图片大小不能超过 2MB!",
    LogoFormate: "上传Logo图片只能是 JPG或PBG 格式!",
    LogoSize: "上传Logo图片大小不能超过 2MB!",
    StandardService: "标准服务",
    RemotePrint: "远程打印",
    copyrightInformation: "版权信息",
    template: `模板："Copyright @ 2019-2022 英文简称 All Rights Reserved 公司名 版权所有 备案号"`
  },
  //用户管理
  usercontrol: {
    Add: "添加",
    UserGroup: "用户名",
    FILE_REAL_H: "真实姓名",
    belonging: "归属客户",
    bituser: "用户类型",
    phone: "联系电话",
    email: "邮箱",
    user_admin: "用户角色",
    recently: "最近登录",
    Operation: "操作",
    detailed: "详细信息",
    userinfo: "新增用户信息",
    userDisplay: "用户密码",
    NICKNAME_RE: "用户昵称",
    Gender: "性别",
    Male: "男",
    Female: "女",
    users_grid: "用户身份",
    socialize: "QQ/微信",
    email: "邮箱",
    address: "地址",
    notesData: "备注",
    cancel: "取消",
    Determine: "确定",
    USER_UPDATE: "用户详情",
    user_exists: "修改用户",
    change_password: "修改密码",
    New_Object: "新密码",
    changePassword: "确认新密码",
    errmessage1: "用户名由任意数字、字符串、下划线组成",
    errmessage2: "用户密码由任意数字、字符串、下划线组成，必须超过6位小于16位",
    errmessage3: "用户权限为必选",
    errmessage4: "用户身份为必选项",
    errmessage5: "请输入正确的手机号码",
    errmessage6: "两次密码输入不一致",
    errmessage7: "用户密码由任意数字、字符串、下划线组成，必须超过6位小于16位",
    usertype1: "普通用户",
    usertype2: "客户管理员",
    usertype3: "系统管理员",
    usertype4: "系统超级管理员",
    message1: "添加成功",
    message2: "此邮箱已被注册",
    message3: "此手机号已被注册",
    message4: "此用户名已被注册",
    message5: "添加失败",
    message6: "删除成功",
    message7: "无法删除系统超级管理员",
    message8: "删除失败",
    message9: "修改成功",
    message10: "修改失败",
    user_page_q_exports: "删除用户",
    Mandatory: "必填",
    Optional: "选填",
    choose: "必选",
    search1: "用户名",
    search2: "真实姓名",
    search3: "归属客户",
    search4: "用户类型",
    search5: "手机",
    search6: "邮箱",
    search7: "用户角色",
    search8: "最近登录",
    alarmSetting: "报警设置",
    monitorSetting: "云监测功能",
    alarmTips: "确认开启设备下线报警提醒？",
    monitorTips: "确认开启云监测功能？",
    monitorCloseTips: "确认关闭云监测功能？",
    alarmCloseTips: "确认关闭设备下线报警提醒？",
    selectRoleTips: "请选择用户角色",
    selectCustomerTips: "请选择用户身份",
    selectTelTips: "请填写联系电话",
    selectEmailTips: "请填写邮箱",
  },
  // 参数管理
  parameter: {
    name: "参数名",
    description: "参数描述",
    value: "参数值",
    time: "添加/修改时间",
    chineseName: "参数中文名重复",
    englishName: "参数英文名重复",
  },
  //删除弹出框
  DeleteBox: {
    prompt: "提示",
    Tetx: "此操作将永久删除该数据, 是否继续?",
    confirmButtonText: "确定",
    cancelButtonText: "取消",
  },
  // n2n
  n2n: {
    serverName: "服务名",
    version: "软件版本",
    port: "端口号",
    totalGroups: "分组总数",
    totaldevices: "设备总数",
    createTime: "创建时间",
    groupManagement: "n2n分组管理",
    groupInfo: "分组信息",
    groupName: "分组名",
    customer: "归属客户",
    username: "远程账号",
    password: "远程密码",
    ip: "远程IP",
    remotePort: "远程端口",
    deivceNumber: "设备数目",
    migrate: "迁移分组所属服务",
    target: "目标服务",
    original: "原服务",
    originalN2N: "原N2N",
    targetN2N: "目标N2N",
    confirmTips: "此操作将修改该分组n2n服务, 是否继续?",
    groupComfirm: "此操作将修改该n2n下的所有分组, 是否继续?",
    inputEmpty: "不能为空",
    versionEmpty: "n2n版本不能为空",
    versionInt: "n2n版本只能为整数",
    portRang: "请输入9001~50000的端口",
    serverEmpty: "服务名不能为空",
    // 服务地址不可以为空
    serverAddressEmpty: "服务地址不可以为空",
    portRepeat: "端口号重复",
    PresenceDevice: "n2n下存在设备",
    PresenceGroup: "n2n下存在分组",
    deleteN2n:
      "删除N2N服务，将导致改服务下所有设备的远程功能失效，确定要删除吗？",
    serverAddress: "服务地址",
    groupAutomaticDistribution: "分组自动分发",
    // 输入分组名称
    inputGroupName: "远程账号",
    // 分组提示
    groupTips: "勾选该选项后，创建分组时，该服务会被自动分配到新分组",
    queryTeam: "(查询账号所属服务)"
  },
  xlsx: {
    export: "导出",
  },
  // 下挂设备
  HangingDevice: {
    alias: "名称",
    vendor: "供应商",
    type: "型号",
    status: "状态",
    lastts: "最后打印时间",
    did: "服务器did",
    dsn: "服务器序列号",
    printeMethod: "打印方式",
    port: "端口",
    serialNumber: "序号",
    edit: "编辑",
    offline: "离线",
    online: "在线",
    Description: "描述",
    successNumber: "打印成功数",
    failNumber: "打印失败数",
    totalNumber: "打印总数",
    finalTime: "最后打印时间",
  },
  // 打印驱动管理
  PrinterDriver: {
    printDrive: "打印驱动地址",
    printType: "型号",
    printDriveSearch: "根据驱动地址搜索",
    printTypeSearch: "根据型号搜索",
    driveSign: "驱动标志",
    common: "普通",
    special: "特殊",
    debugFlag: "调试标志",
    notDebugging: "未调试",
    debuggingThrough: "调试通过",
    debuggingFailed: "调试未通过",
    printTypeInput: "请输入打印机型号",
    driveSignSelect: "请选择驱动标志",
    debugFlagSelect: "请选择调试标志",
    printDriveInput: "请输入打印机驱动地址",
    remark: "备注",
    remarkInput: "请输入备注",
  },
  /**
   * 云监测
   */
  // 报警通知
  Confirm: {
    SuccessfullyDelete: "刪除成功",
    DeleteFailed: "删除失败，请重试！",
    SuccessfullyAdd: "添加成功",
    AddFailed: "添加失败，请重试",
    SuccessfullyEdit: "编辑成功",
    EditFailed: "编辑失败，请重试",
  },
  Input: {
    placeholder: "请选择",
    inputPlaceholder: "请输入",
  },
  // 监控大屏
  Monitor: {
    MonitorScreen: "监控大屏",
    systemOverview: "系统总览",
    deviceConfiguration: "设备组态",
    deviceOverview: "设备概况",
    deviceTotalNumber: "设备总数",
    totalOffline: "离线总数",
    totalOnline: "在线总数",
    deviceList: "设备列表",
    deviceSearch: "SN/名称",
    disconnected: "未连接",
    connected: "已连接",
    alarmStatistics: "报警统计",
    todayTotalNumber: "今日报警总数",
    todayProcessedNumber: "今日已处理总数",
    todayUnprocessedNumber: "今日未处理总数",
    alarmInfo: "报警信息",
    alarmHandling: "报警处理",
    alarmStartTime: "报警开始时间",
    alarmEndTime: "报警结束时间",
    alarmResult: "报警结果",
    Unprocessed: "未处理",
    Processed: "已处理",
    ProcessingDescription: "处理描述",
    device: "设备",
    terminal: "终端",
    variable: "变量",
    content: "内容",
    deviceInfo: "设备信息",
    historyData: "历史数据",
    historyAlarm: "历史报警",
    deviceName: "设备名称",
    deviceAddress: "设备地址",
    project: "所属项目",
    terminalName: "终端名称",
    setVariable: "设置变量",
    to: "至",
    search: "查询",
    export: "导出",
    addedVariable: "已添加变量",
    realTimeAlarm: "实时报警数据",
    realTimeMonitoring: "实时监控",
    terminalRealTimeData: "实时终端数据",
    pleaseTerminal: "请选择终端",
    pleaseVariable: "请选择变量",
    Pleasetime: "请选择时间",
    Open: "开",
    Close: "关",
    collectionTime: "采集时间",
    pleaseModifyValu: "请输入修改值",
    loading: "加载中...",
    setValue: "修改值",
    noData: "没有找到数据。 请检查您的搜索条件！",
  },
  // 快速接入
  FastAccess: {
    addProject: "添加项目",
    addDevice: "添加设备",
    addTerminal: "添加终端",
    addTemplate: "采集配置",
    startCollecting: "启动采集",
    projectName: "项目名称",
    deviceSn: "设备序列号",
    terminalName: "终端名称",
    projectTips1: "您的项目为",
    projectTips2: "可在项目列表查看详细信息",
    deviceTips1: "设备为",
    deviceTips2: "可在设备列表查看详细信息",
    terminalTips1: "终端为",
    terminalTips2: "可在终端列表查看详细信息",
    continueAdd: "继续添加",
    successTips: "您已操作成功！",
    BelogingUser: "所属用户",
    ownCustomer: "所属客户",
    projectType: "项目类别",
    selectProject: "选择已有项目",
    genericType: "通用类型",
    pleaseName: "请输入名称",
    pleasecustomer: "请选择客户",
    pleaseProject: "请选择项目所属客户",
    firstGrouping: "一级分组：",
    next: "下一步",
    backNewProject: "返回新建项目",
    levelGrouping: "项目一级分组：",
    secondaryGrouping: "项目二级分组：",
    previous: "上一步",
    NewTemplate: "新建采集模板",
    IssueCollection: "下发采集",
    ConfirmAdd: "确认添加",
    pleaseTname: "请输入模板名称",
    selectedCollection: "请输入选择采集方式",
    collectionTemplate: "已有采集模板",
    warning1: "尚存在变量未下发采集指令，请先下发采集指令！",
    Failedtoadddevice: "设备添加失败",
    tryagain: "请求失败，请重试",
    pleasechooseanother: "此设备未连接，请重新选择设备！",
    Failedtoeditgroup: "编辑分组失败",
    Failedtoaddgroup: "添加分组失败",
    Commandissuedsuccessfully: "指令下发成功",
    variablesfirst: "请先添加变量!",
    variablelist: "获取变量列表失败!",
    configurationfailed: "终端串口配置失败！",
    terminalcommands: "终端指令下发失败！",
    Failedtoaddterminal: "添加终端失败"
  },
  // 变量列表
  variableList: {
    seriableNumber: "序号",
    name: "变量名",
    unit: "单位",
    registerMode: "寄存器方式",
    registerAddress: "寄存器起始地址",
    dataType: "数据类型",
    byteOrder: "字节序",
    triggerType: "上报类型",
    triggerPeriod: "上报周期",
    calculationFactor: "计算因子",
    decimalPrecision: "小数精度",
    setThreshold: "设置阈值",
    minimum: '最小值',
    maximum: '最大值',
    value: '值'
  },
  // 设备管理
  devicesManagement: {
    FastAccess: "快速接入",
    ProjectGroup: "项目列表",
    TerminalList: "终端列表",
    CollectConfigurate: "采集配置",
    EditCollection: "添加变量",
    AddDevice: "添加设备",
    AddTerminal: "添加终端",
    deviceList: "设备列表",
    variableList: "变量列表",
    addATemplate: "添加模板",
    editATemplate: "修改模板",
    Noprojectgroups: "未选择项目分组和设备！",
    Nodeviceselected: "未选择设备！",
    Noprojectgroup: "未选择项目分组！",
    Addedsuccessfully: "添加成功！",
    webssh: "远程终端",
    remoteWeb: "远程web",
  },
  // 项目列表
  projectList: {
    name: "名称",
    projectName: "项目名称",
    BelogingCustomer: "归属客户",
    creator: "创建者",
    createTime: "创建时间",
    AddProject: "添加项目",
    EditProject: "编辑项目",
    FirstProjectGroup: "一级分组",
    BelogingUser: "所属用户",
    projectType: "项目类型",
    generictype: '通用类型',
    confirmdeletion: '确认删除?',
    cannotbedeleted: "项目分组存在设备，无法删除！"
  },
  // 报警管理类
  alarmManagement: {
    alarmManagement: "报警管理",
    AlarmNotice: "报警通知",
    AlarmContact: "报警联系人",
    AlarmList: "报警记录",
    viewterminal: "查看终端"
  },
  // 报警通知
  alarmNotice: {
    device: "设备",
    terminal: "终端",
    variable: "变量",
    alarmContent: "报警内容",
    alarmStartTime: "报警开始时间",
    alarmEndTime: "报警结束时间",
    triggering: "触发条件",
    enable: "已启用",
    disabled: "未启用",
    add: "添加",
    serialNumber: "序号",
    eventName: "事件名称",
    way: "方式",
    information1: "通知信息(报警)",
    information2: "通知信息(恢复)",
    tsn: "终端SN（名称）",
    pushMechanism: '推送机制',
    once: "一次",
    repeatedly: "多次",
    state: "状态",
    AlarmContact: "报警联系人",
    operate: "操作",
    EditingAlarm: "编辑报警通知",
    Addalarm: '添加报警通知',
    email: "邮箱",
    Alarmterminal: '报警终端',
    timeInterval: "时间间隔",
    minute: "分钟",
    msg1: "请输入报警通知名称",
    msg2: "请选择报警方式",
    msg3: "请选择报警终端和报警联系人！",
    msg4: "请选择报警终端！",
    msg5: '请选择报警联系人！',
    msg6: '修改成功！',
    msg7: '修改失败，请重试！',
    msg8: '添加成功！',
    msg9: '添加失败，请重试！',
    pleaseChoose: '请选择',
    Alarmoperate: '报警操作',
    numberValue: '数值',
    Newcontact: '新建联系人'
  },
  // 统计报表
  statictics: {
    HistoryRecords: "历史记录",
    DevicesStatus: "设备上下线",
  },
  Button: {
    Add: "添加",
    submit: "提交",
    confirm: "确定",
    cancel: "取消",
    edit: "编辑",
    delete: "删除",
    operation: "操作",
    tips: "提示",
    isDelete: "确定删除？",
    successDelete: "删除成功！",
    failDelete: "删除失败！",
    successEdit: "修改成功！",
    failEdit: "修改失败",
    successSetting: "设置成功！",
    failSetting: "设置失败",
    successOperation: "操作成功！",
    failOperation: "操作失败，请重试！",
    successConfiguration: "配置成功",
    failConfiguration: "配置失败",
    successAdd: "添加成功！",
    failAdd: "添加失败！",
    refresh: '刷新服务器地址',
  },
  // 顶部导航
  navTab: {
    devicesManagement: "设备管理",
    monitorCloud: "云监测",
  },
  //切卡记录
  switchCrad: {
    switchCradRecord: "切卡记录",
    startDate: "开始日期",
    endDate: "结束日期",
    Inquire: "查询",
    serialNumber: "序号",
    OperatorFront: "运营商(前)",
    ViewChekaRecords: "查看切卡记录",
    ICCIDFront: "ICCID(前)",
    SignalFront: "信号(前)",
    operatorRear: "运营商(后)",
    ICCIDRear: "ICCID(后)",
    SignalRear: "信号(后)",
    ChekaTime: "切卡时间",
    Cancel: "取 消",
  },
  //上下线记录
  onAndOf: {
    OnlineAndOfflineRecords: "上下线记录",
    time: "时间",
    type: "类型",
    offline: "下线",
    online: "上线",
    all: "全部",
    GetFailed: "获取失败!",
    repair: "设备修复",
  },
  //变量列表
  varlist: {
    terminalType: "终端类型",
    ReturnToTerminalList: "返回到终端列表",
    Inquire: "查询",
    PleaseEnterVariableName: "请输入变量名",
    terminalName: "终端名称",
    aName: "请输入名称",
    varNmae: "变量名称",
    Selectendian: "选择字节序",
    Choosereporttype: "选择上报类型",
    controltype: "控制类型",
    precision: "精度",
    Selectdatatype: "选择数据类型",
    maximumvalue: "请输入最大值",
    minimumValue: '请输入最小值',
    confirm1: "此操作将永久删除该数据, 是否继续?",
    variabletype: "该变量类型无法设置阈值!",
    sendcollection: "下发采集失败!",
    ActionThresholdFailed: "操作阈值失败!",
    viewterminal: "查看终端",
  },
  //终端列表
  terminalList: {
    add: '添加',
    name: '名称',
    serialNumber: '序列号',
    templateName: '模板名称',
    protocol: '协议',
    describe: '描述',
    Edittheterminaldevice: "编辑终端设备",
    Addaterminaldevice: "添加终端设备",
    Fillintheterminalinformation: "填写终端信息",
    Collectionconfigurationtemplate: "采集配置模板",
    Templatecategory: "模板类别",
    Protocol: "协议",
    Equipment: "所属设备",
    Name: "名称",
    SlaveID: "从站ID",
    Valuerange: "取值范围：0~",
    Slaveaddress: "从站地址",
    Port: "端口",
    SerialportNo: "设备串口号",
    Pleaseselecttheequipmentfirst: "请先选择所属设备",
    Configureserialportinformation: "配置串口信息",
    Cancel: "取消",
    Confirm: "确认",
    // 
    Successfullymodified: "修改成功!",
    Successfullyadded: "添加成功!",
    Requestfailed: '请求失败',
    Serialportconfigurationfailed: '串口配置失败！',
    Failedtoissuethecommand: "指令下发失败！",
    Collectionfailed: "终端信息采集失败，请确认终端基本信息参数！",
    Collectionrequesterror: "终端信息采集请求错误！",
    Modificationfailed: '修改失败，请重试！',
    Addingfailed: '添加失败，请重试！',
    Notselected: "未选择所属设备",
    Incorrectfilling: "终端信息未正确填写！",
    form1: "请选择采集配置模板",
    form2: "请选择所属设备",
    form3: '请输入从站ID',
    form4: "不可以为负数",
    form5: "从站ID取值范围：0~",
    form6: "请输入从站地址",
    form7: "从站地址输入错误",
    form8: "端口号错误",
    form9: "请输入终端名称",
    form10: "无数据",
    form11: "请选择终端协议",
    form12: "端口号不符合",
    Basicinformation: "终端设备基本信息",
    Protocolinformation: '协议信息',
    TerminalDetails: "终端设备详情",
    details: "详情",
    returntodevicelist: "返回到设备列表",
    Terminalinformation: "终端信息采集出错，请检查终端信息参数！",
    collectionrequesterror: '终端信息采集请求出错！',
    hiddenTerminal: "隐藏终端",
    nohiddenTerminal: "非隐藏终端",
    terminalNumber: "终端编号",
    monitoringLocation: "监控地点",
    accessTime: "接入时间",
    showDetail: "是否隐藏此终端",
    tip: "提示",
    copySuccess: "复制成功",
    copyFail: "复制失败",
    deleteDetail: "是否删除此终端",
    refresh: '刷新',
    plsupdate: '该服务不支持自动刷新，如需更新数据请手动点击刷新按钮',
    index: '序号',
    ip: "IP地址",
    mac: 'MAC地址',
    networkInterface: '网络接口',
    operate: '操作',
    directAccess: '直接访问',
    configAccess: '配置访问',
    connectTips: '连接提示',
    stopClose: '请不要关闭此窗口，关闭后视为断开连接!',
    portToAccess: '要访问的端口',
    urlToAccess: '要访问的路径',
    EstablishConnection: '建立连接',
  },
  //采集配置
  collect: {
    templateName: '模板名称',
    TemplateType: '模板类型',
    Updateddate: '更新日期',
    TemplateInformation: "模板信息",
    save: "保存",
    variableInformation: "变量信息",
    PleaseSave: "添加变量前请先保存模板信息",
    IssueCollection: "下发采集",
    Cancel: "取消",
    describe: "描述",
    addVariable: "添加变量",
    serialNumber: '序号',
    variableName: "变量名",
    unit: "单位",
    registertype: "寄存器类型",
    startaddress: '寄存器起始地址',
    typeofdata: '数据类型',
    endian: "字节序",
    Reportingtype: '上报类型',
    Reportingcycle: '上报周期',
    second: '秒',
    calculationfactor: '计算因子',
    decimalprecision: '小数精度',
    IOcontrollertype: 'IO控制器类型',
    interfacenumber: '接口号码',
    functiontype: '功能类型',
    operate: '操作',
    msg1: '此操作将永久删除该数据, 是否继续?',
    msg2: '提示',
    msg3: '确认',
    msg4: '删除成功！',
    msg5: '指令下发成功！',
    msg6: '指令下发失败，请重试！',
    msg7: '该变量正在执行采集任务，请先停止再删除！',
    msg11: "改模板有终端正在使用，不可以将其删除!",
    msg8: '删除失败，请重试！',
    msg9: '请选择采集模板！',
    msg10: "表单信息未正确填写！",
    setalarm: "设置报警",
    Callthepolice: "报警：",
    Triggeringconditions: "触发条件：",
    PleasevalueA: "请输入数值A",
    PleasevalueB: "请输入数值B",
    Alarmpushcontent: "报警推送内容：",
    Restorepushcontent: "恢复推送内容：",
    SwitchOFF: "开关OFF",
    switchON: "开关ON",
    valuelessA: '数值小于A',
    valuegreaterB: "数值大于B",
    ValuegreaterAlessB: "数值大于A且小于B",
    ValuelessAgreaterB: '数值小于A或数值大于B',
    valueisequaltoA: "数值等于A",
    Failedtoobtain: "报警规则获取失败！",
    Setupsucceeded: "设置成功！",
    Setupfailed: "设置失败，请重试",
    Savefailed: "保存失败，请重试！",
    pleaseTcontent: '请输入报警推送内容'
  },
  //编辑变量
  editVar: {
    Editvariables: '编辑变量',
    addvariable: '添加变量',
    type: '类型',
    rawtype: '读写类型',
    variableunit: '变量单位',
    inputrange: '输入范围：0~65535',
    typedata: '数据类型',
    reportingperiod: '请输入上报周期',
    calculationfactor: '请输入计算因子',
    decimalprecision: '小数精度',
    msg1: '请输入计算因子，且不能为0',
    msg2: '计算因子不能为0',
    msg3: "计算因子只可以是数字",
    msg4: '寄存器地址错误，输入范围：0~65535',
    msg5: '请选择功能类型',
    msg6: '请输入变量名称',
    msg7: '请选择寄存器类型',
    msg8: '请选择变量类型',
    msg9: '请输入变量单位',
    msg10: '范围只可以0~65535之间',
    msg11: '请输入变量小数精度',
    msg12: '请选择数据类型',
    msg13: '请选择字节序',
    msg14: '请选择上报类型',
    msg15: '请输入上报周期',
    msg16: '请输入接口号码',
    msg30: "请输入正确的sid",
    relay1: '继电器1',
    relay2: '继电器2',
    bool: "布尔型（bool）",
    readandwrite: '读写',
    read: '只读',
    msg17: '修改成功！',
    msg18: '修改失败，请重试！',
    msg19: '添加成功！',
    msg20: '添加失败，请重试！',
    msg21: '输入自定义的值',
    msg22: '提示',
    msg23: '确定',
    msg24: '取消',
    msg25: '只可以是数字',
    msg26: '自定义',
    msg27: '取消输入',
    msg28: "改变量无法修改值",
    Pleaseentertheunit: "请输入单位",
    msg28: "单位长度过长",
    msg29: "单位不能为空",
    pleaseEnterAValidValue: "请输入有效值",
    pleaseEnterInt32: "请输入int32类型的值",
    pleaseEnterUint32: "请输入uint32类型的值",
  },
  smartcat: {

  },
  openvpn: {
    name: "名称",
    recipe: "模式",
    enabled: "启用",
    open: "开启",
    close: "关闭",
    port: "端口",
    proto: "协议",
    status: "已运行的",
    yes: "是",
    no: "否",
    constatus: "状态",
    start_stop: "启动/停止",
    start: "启动",
    stop: "停止",
    operate: "操作",
    edit: "编辑",
    noConnect: "未连接",
    connecting: "连接中",
    actionOk: "启动成功",
    stopOk: "暂停成功",
    configuration: "编辑",
    tips1: "设置输出冗余级别",
    tips2: "端口 TCP/UDP 端口 # 同时针对本地和远程",
    tips3: "使 tun 设备兼容 IPv6",
    tips4: "使用设备类型",
    tips5: "server 配置服务器模式",
    tips6: "配置服务器桥接",
    tips7: "nobind 不绑定本地地址和端口",
    tips8: "加密数据包",
    tips9: "使用快速 LZO 压缩",
    tips10: "在 2.4+ 版本上使用压缩选项",
    tips11: "在服务配置模式下简化 Helper 指令 --ping 和 --ping-restart 的表达式",
    tips12: "采用协议",
    tips13: "配置客户端模式",
    tips14: "远程主机名或 ip 地址",
    tips15: "认证方式，默认使用 ca 证书认证",
    tips16: "以用户名/密码的方式进行验证",
    tips17: "选择文件",
    tips18: "secret 允许静态密钥加密模式",
    tips19: "cert PEM格式本地证书",
    tips20: "PKCS#12 文件包含的密钥",
    tips21: "Diffie-Hellman/DH 密钥交换参数",
    tips22: "本地私钥",
    tips23: "TLS加密秘钥",
    tips24: "dev tun/tap 设备",
    addSelect: "添加",
    saveEdit: "保存",
    moreSelect: "--更多选项--",
    selected: "已选择",
    noFile: "暂无相关文件",
    verb: "冗余级别",
    port: "端口",
    changeProcessPriority: "改变进程优先级",
    proto: "协议",
    client: "客户端模式",
    remote: "VPN服务器",
    keepalive: "保活间隔及空闲时长",
    comp_lzo: "快速LZO压缩",
    compress: "压缩",
    cipher: "加密算法",
    nobind: "无绑定",
    tun_ipv6: "IPv6支持",
    nice: "进程优先级",
    server: '服务器模式',
    server_bridge: '服务器桥接',
    dev_type: '设备类型',
    auth_method: '认证方式',
    auth: '认证参数',
    username: '用户名',
    password: '密码',
    secret: '静态密钥',
    pkcs12: 'PKCS#12文件',
    ca: 'CA根证书',
    dh: '使用DH协议文件',
    cert: '证书',
    key: "私钥",
    tls_crypt: '使用TLS-共享密钥',
    authParameter: 'auth参数',
    useStaticKeys: '使用静态密钥',
    addtlsauth: '添加tls-auth配置',
    enabletlsauth: '使用TLS认证',
    tlsAuth: 'TLS认证',
    enableDh: '使用DH协议文件',
    addDh: '添加DH配置',
    enablePkcs: '使用PKCS#12文件',
    addPkcs: '添加PKCS#12配置',
    enabletlscrypt: '使用TLS-共享密钥',
    addtlscrypt: '添加TLS-共享密钥配置',
    cacert: 'CA根证书',
    username2: '用户名 密码',
    usernameCacert: '用户名 密码+CA证书',
    dev: '设备',
  },
  repeater: {
    refsh: "刷新",
    universal: "通用",
    serverConfig: "服务器配置",
    enable: "启用",
    operatingModel: "工作模式",
    protocol: '协议',
    serverAddress: "服务器地址",
    heartbeatCycle: "心跳周期",
    second: "秒",
    state: "状态",
    noConnect: "未连接",
    connectNumber: "连接数",
    relayConfig: "中继配置",
    reportTerminal: "上报终端",
    name: "名称",
    listenPort: "监听端口",
    sendTo: "发送至",
    ipRules: "IP1:port IP2port2...#多个ip:port之间由空格隔开",
    del: "删除",
    add: "添加",
    serailConfig: "串口配置",
    interface: "接口",
    baudrate: "波特率",
    data_bits: "数据位",
    stop_bits: "停止位",
    parity: "校验位",
    flow: "流控",
    edit: "编辑",
    adv: "高级",
    advConfig: "高级配置",
    trueOn: "开启",
    debug: "调试",
    tcpKeep: "TCP保活空闲时长",
    tcpKeep2: "TCP保活探测间隔",
    tcpKeep3: "TCP保活探测最大次数",
    logNumber: "保留日志文件个数",
    logSize: "日志文件大小",
    logPriority: "日志优先级",
    info: "信息",
    notice: "注意",
    warn: "警告",
    error: "错误",
    fatal: "致命",
    alert: "警戒",
    urgent: "紧急",
    logFile: "日志文件",
    download: "下载",
    SaveApply: "保存并应用",
    numberRuleErr: "请输入正确的数值",
    ipRuleErr: "ip地址不合法",
    portRuleErr: "端口号不正确",
    nameRuleErr1: "存在此名称",
    nameRuleErr2: "0~31之间",
    heartbeatRuleErr: "请输入心跳周期",
    numberRuleErr2: "请输入名称",
    tcpRuleErr: "请输入TCP保活空闲时长",
    tcpRuleErr2: "请输入TCP保活探测间隔",
    tcpRuleErr3: "请输入TCP保活探测最大次数",
    logRuleErr: "请输入保留日志文件个数",
    logRuleErr2: "请输入日志文件大小",
    saveSuccess: "保存成功",
    seniorErr: "高级配置表单未完善",
    serverErr: "服务器配置参数不正确",
    repeaterErr: "中继器配置未完善",
    repeaterErr2: "该设备暂无中继器配置",
    sec: "秒"
  },
  IOControl: {
    universal: "通用",
    DIDigitalInput: "DI 数字量输入",
    deviceName: "设备名称",
    pleaseDeviceName: "请输入设备名称",
    interfaceName: "接口名称",
    deviceState: "设备状态",
    DODigitalInput: "DO 数字量输出",
    start_stop: "启动/停止",
    close: "关闭",
    open: "打开",
    relay: "继电器",
    senior: "高级",
    seniorConfig: "高级配置",
    trueOn: "开启",
    debug: "调试",
    info: "信息",
    notice: "注意",
    warn: "警告",
    error: "错误",
    fatal: "致命",
    alert: "警戒",
    urgent: "紧急",
    logNumber: "保留日志文件个数",
    logSize: "日志文件大小",
    logPriority: "日志优先级",
    logFile: "日志文件",
    download: "下载",
    SaveApply: "保存并应用",
    enable: "启用",
    editSuccess: "修改成功",
    refresh: "刷新",
    msgok: "操作成功",
    msgfaile: "操作失败",
    disable: "关闭",
    msg1: "请先开启"
  },
  unit: {
    registerTypeObj1: "读线圈",
    registerTypeObj2: "读输入状态",
    registerTypeObj3: "读保持寄存器",
    registerTypeObj4: "读输入寄存器",
    dataFormatObj1: "16位 无符号",
    dataFormatObj2: "16位 有符号",
    dataFormatObj3: "16位 BCD",
    dataFormatObj4: "32位 无符号(AB CD)",
    dataFormatObj5: "32位 无符号(CD AB)",
    dataFormatObj6: "32位 有符号(AB CD)",
    dataFormatObj7: "32位 有符号(CD AB)",
    dataFormatObj8: "32位 浮点数(AB CD)",
    dataFormatObj9: "32位 浮点数(CD AB)",
    dataFormatObj10: "32位 浮点数(CD AB)",
    dataFormatObj11: "32位 BCD",
    dataFormatObj12: "32位 BCD",
    dataFormatObj13: "位",
    dataFormatObj14: "32位 时间戳",
    dataFormatObj15: "32位 时间戳",
    ioControlListObj0: "通用型",
    ioControlListObj1: "风扇",
    ioControlListObj2: "光声报警器",
    ioControlListObj3: "烟雾报警器",
    modbusListObj0: "通用型",
    modbusListObj1: "温度",
    modbusListObj2: "湿度",
    typeListObj0: "Modbus",
    typeListObj1: "IO控制",
    dataTypeObj1: "16位 有符号（int16）",
    dataTypeObj2: "16位 无符号（uint16）",
    dataTypeObj3: "32位 有符号（int32）",
    dataTypeObj4: "32位 无符号（uint32）",
    dataTypeObj5: "64位 有符号（int64）",
    dataTypeObj6: "64位 无符号（uint64）",
    dataTypeObj7: "浮点数 单精度（float）",
    dataTypeObj8: "浮点数 双精度（double）",
    dataTypeObj9: "字符串（string）",
    dataTypeObj10: "布尔型（bool）",
    dataTypeObj11: "自定义（custom）",
    dataTypeObj12: "时间类型（int64）",
    dataTypeObj13: "raw",
    endianObj1: "高端字节序（ABCD）",
    endianObj2: "低端字节序（CDAB）",
    triggerObj2: "周期上报",
    triggerObj3: "状态变更",
    triggerObj4: "从不上报",
    storageModeObj1: "变化存储",
    storageModeObj2: "全部存储",
    rorwObj1: "只读",
    rorwObj2: "只写",
    //
    unitObj1: "摄氏度(℃)",
    unitObj2: "帕(Pa)",
    unitObj3: "伏特(volt)",
    unitObj4: "百分比(%)",
    unitObj5: "毫安(mA)",
    unitObj6: "欧姆(Ω)",
    unitObj7: "无",
    registerTypeOptions1: "1(线圈状态)",
    registerTypeOptions2: "2(输入状态)",
    registerTypeOptions3: "3(保持寄存器)",
    registerTypeOptions4: "4(输入寄存器)",
  },
  //报警记录
  alarmList: {
    serialNumber: "序号",
    devicename: "设备名称",
    terminalname: "终端名称",
    variable: "变量",
    currentvalue: "当前值",
    Triggeringconditions: '触发条件',
    Notificationinformation: '通知信息(报警)',
    Notificationinformation2: "通知信息(恢复)",
    starttime: "报警开始时间",
    endtime: "报警结束时间",
    Alarmstatus: '报警状态',
    restored: "已恢复",
    inalarm: "报警中",
    operate: "操作",
    Handlingalarms: '处理报警',
    ProcessDescription: '处理描述',
    msg1: '处理成功！',
    msg2: '处理失败！',
    msg3: '请求失败，请重试！'
  },
  //报警联系人
  alarmContact: {
    name: "姓名",
    phone: '手机号',
    email: '邮箱',
    wechat: "微信",
    Remark: '备注',
    add: "添加",
    EditContact: "编辑联系人",
    Addcontacts: '添加联系人',
    new: "新增",
    msg1: "请填写手机号",
    msg2: "请填写邮箱",
    msg3: "请输入姓名",
    msg4: "该手机号已存在！",
    msg5: '手机号格式不正确',
    msg6: '该邮箱已存在！',
    msg7: '修改成功！',
    msg8: '修改失败，请重试！',
    msg9: '添加成功！',
    msg10: '添加失败，请重试！',
    wxandemail: '微信、邮箱',
    Shortmessage: '短信',
    Emaildoesnot: "邮箱不符合格式"
  },
  rightAlarm: {
    Nopermission: '无权限',
    Alarmhandling: '报警处理',
    Alarmstart: '报警开始时间：',
    Alarmend: '报警结束时间：',
    Alarmresult: '报警结果：',
    notprocessed: '未处理',
    Processing: '处理描述：',
    save: '保存',
    equipment: '设备：',
    terminal: '终端：',
    variable: '变量：',
    content: '内容：',
    msg1: '保存成功！',
    msg2: '保存失败！',
    msg3: '请求失败， 请重试！'
  },
  networkMonitoring: {
    configuration: '配置',
    enabled: '启用',
    operatingMode: '操作模式',
    pleaseChoose: '请选择',
    restartAfterNetworkDisconnection: '断网重启',
    periodicRestart: '周期重启',
    detectionAddress: '检测地址',
    pleaseEnter: '请输入',
    detectionCycle: '检测周期',
    recoveryPeriod: "恢复周期",
    tips1: "检测网络连接的频率,单位为秒",
    tips2: " 默认单位为秒，您可以使用'm'作为后缀表示分钟，‘h’表示小时‘d’表示天。",
    save: '保存',
    msg1: '获取数据失败!',
    msg2: '保存成功!',
    msg3: '保存失败!',
    msg4: '请填写正确的表单',
    repeatCycle: '重复周期',
  },
  //智慧电梯
  smartele: {
    updateInterval: "请填写正确的更新周期",
    log_file_num: "请填写正确的日志文件数量",
    log_file_size: "请填写正确的日志文件大小",
    server: "服务器",
    customerID: "客户ID",
    MQTTQualityofService: "MQTT服务质量",
    sessionCleanup: "会话清理",
    keepInformation: "保留信息",
    policyConfiguration: "策略配置",
    EscalationPolicy: "上报策略",
    ReportRegularly: "定时上报",
    ChangeReporting: "变化上报",
    ReportAllAttributes: "全属性上报",
    NonFullAttributeReporting: "非全属性上报",
    speed: "速度",
    ValueMethod: "取值方式",
    averageValue: "平均值",
    instantaneousValue: "瞬时值",
    timeInterval: "时间间隔",
    ReportingThreshold: "上报阈值",
    acceleration: "加速度",
    barometricPressure: "气压",
    TheSamplingPeriod: "采样周期",
    floatingValue: "浮动值",
    NumberOfFloats: "浮动次数",
    high: "高度",
    temperature: "温度",
    humidity: "湿度",
    DirectionOfMovement: "运动方向",
    motionTOstill: "运动 -> 静止",
    stillToMoving: "静止 -> 运动",
    doorStatus: "门状态",
    notClosedToClosed: "未关闭 -> 已关闭",
    closedToNotClosed: "已关闭 -> 未关闭",
    flatState: "平层状态",
    NonFlatLayerToFlatLayer: "非平层 -> 平层",
    FlatLayerToNonFlatLayer: "平层 -> 非平层",
    GrassrootsState: "基层状态",
    NonGrassrootsToGrassroots: "非基层 -> 基层",
    GrassrootsToNonGrassroots: "基层 -> 非基层",
    PersonnelStatus: "人员状态",
    noOneToSomeone: "无人 -> 有人",
    someoneToNoOne: "有人 -> 无人",
    SerialPortConfiguration: "串口配置",
    DataUpdateCycle: "数据更新周期",
    // 错误提示
    errorMsg: "请输入正确的值",
    LOGOFacingUp: 'LOGO朝上',
    toward: '朝向',
    lightUp: '指示灯朝上'
  },
  // sms短信
  smartsms: {
    configuration: '配置',
    inbox: '收件箱',
    outbox: '发件箱',
    advanced: '高级',
    mobileNetwork: '移动网络',
    SIM1Number: 'SIM1号码',
    storageLocation: '存储位置',
    SIMCard: 'SIM卡',
    equipmentTerminal: '设备终端',
    SMSCenter: '短信中心',
    tips1: "国际区号+手机号码，如861380013800",
    whitelist: '白名单',
    validityPeriod: '有效期',
    DetectionCycle: '接收检测周期',
    saveAndApply: '保存并应用',
    overview: '概览',
    thresholdManagement: '阈值管理',
    storeState: '存储状态',
    CurrentSIMCard: "当前SIM卡",
    messageList: '短信列表',
    serialNumber: '序号',
    telephoneNumber: '电话号码',
    SMSContent: '短信内容',
    date: '日期',
    merge: '合并',
    no: '否',
    yes: '是',
    delete: '删除',
    tips2: '此操作将永久删除该消息, 是否继续?',
    tips: '提示',
    sure: '确定',
    cancel: '取消',
    state: '状态',
    edit: '编辑',
    send: '发送',
    tips3: "最大允许1500字节长度",
    saveAsDraft: '保存草稿',
    sendImmediately: '立即发送',
    FailedToSend: '发送失败',
    SentSuccessfully: "发送成功",
    sending: '发送中',
    draft: '草稿',
    advancedConfiguration: '高级配置',
    notConnect: '暂未连接'
  },
  webssh: {
    connect: '连接',
    newWindwo: '新窗口中打开',
    disconnect: '断开',
    tunnel: '隧道建立中',
    disconnectLoading: '断开连接中',
    'DeviceMQTToffline': '设备MQTT不在线',
    'Failedtoobtainterminaladdress': '获取终端地址失败',
    tunnelErr: '连接隧道失败，请检查网络或设备状态',
    Unexpecteddisconnection: '意外断开连接',
    SelectRoute: "选择线路",
    DEFAULT: "默认",
    ChinaMobile: "中国移动",
    ChinaTelecom: "中国电信"
  }
};
